import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import ReportListResults from 'src/components/report/Reportlist';
import customers from 'src/__mocks__/customers';
const Report = () => (
  <>
    <Helmet>
      <title>Settings | Material Kit</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ pt: 3 }}>
          <ReportListResults customers={customers}  />
        </Box>
      </Container>
    </Box>
  </>
);

export default Report;
